<div class="bg-white min-h-screen w-full flex justify-between pt-5">
  <picture attr.width="177" attr.height="688" class="hero-circle circle-left mt-4">
    <source
      srcset="assets/images/pages/public/home/landing_page/home-hero-left.webp"
      type="image/webp"
      uLazyLoadImage
    />
    <img
      src="assets/images/pages/public/home/landing_page/home-hero-left.png"
      alt=""
      class="profile-img"
      attr.width="177"
      attr.height="688"
      uLazyLoadImage
    />
  </picture>
  <div class="px-3 flex justify-center items-center lg:px-0 mt-8">
    <div class="pt-8 pb-2 lg:py-11 flex flex-col items-center">

      <a routerLink="/" class="py-3">
        <u-logo [textFill]="'#000'" [width]="'126.9'" height="32"></u-logo>
      </a>

      <div class="letter-container">
        <div class="letter-content">
          <p>After 7 incredible years, the time has come to close the chapter on Upkey.<br>
            Building Upkey has been the defining experience of my 30s—a journey filled with grit, growth, and a deep sense of purpose.</p>

          <p>We didn’t just build a tech platform—we built a lifeline.<br>
            Together, we helped over 100,000 students, many from underrepresented and underserved communities, develop the skills, confidence, and clarity to take meaningful steps in their professional lives.</p>

          <p>We showed up when the world shut down. During the height of the pandemic, while everything felt uncertain, Upkey became a source of hope and momentum for young people trying to find their place in the world. That’s something I’ll carry with me forever.</p>

          <p>The professional development space has evolved dramatically, and technology now solves many of the problems we once addressed with human care and creativity. As a result, we’ve made the difficult decision to wind down operations. Still, I am so proud of what we accomplished.</p>

          <p>We made an impact—and that impact lives on in every student who found their voice, landed their first job, or dared to dream a little bigger because of Upkey.<br>
            To everyone who supported this mission: thank you.</p>

          <p>This chapter is closing, but my passion for empowering students and young people remains stronger than ever. I’ll be exploring new ways to serve—whether through mental health, career growth, financial literacy, or community development.</p>
          <div class="letter-signature">
            <p>With gratitude and hope,</p>
            <p>Amir</p>
          </div>
        </div>
      </div>

    </div>
  </div>
  <picture attr.width="198" attr.height="688" class="hero-circle circle-right">
    <source
      srcset="assets/images/pages/public/home/landing_page/home-hero-right.webp"
      type="image/webp"
      uLazyLoadImage
    />
    <img
      src="assets/images/pages/public/home/landing_page/home-hero-right.png"
      alt=""
      class="profile-img"
      attr.width="198"
      attr.height="688"
      uLazyLoadImage
    />
  </picture>
</div>